import { render, staticRenderFns } from "./QuantityWidget.vue?vue&type=template&id=5cfc3930&scoped=true"
import script from "./QuantityWidget.vue?vue&type=script&lang=js"
export * from "./QuantityWidget.vue?vue&type=script&lang=js"
import style0 from "./QuantityWidget.vue?vue&type=style&index=0&id=5cfc3930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc3930",
  null
  
)

export default component.exports